import React from 'react'
import { createEventObjectForWeekView } from '../calendarFunctions'
import {endOfWeek, startOfWeek, eachDayOfInterval, format} from 'date-fns'
import InternalCalendarMenu from '../InternalCalendarMenu/InternalCalendarMenu'
import SmallWeekViewCalendar from './SmallWeekViewCalendar'
import LargeWeekViewCalendar from './LargeWeekViewCalendar'

const WeekViewCalendar = (props) => {
  const container = React.useRef(null)
  const containerNav = React.useRef(null)
  const containerOffset = React.useRef(null)
  const [firstDayOfWeek, setFirstDayOfWeek] = React.useState(startOfWeek(new Date(props.selectedDay.date)))
  const [lastDayOfWeek, setLastDayOfWeek] = React.useState(endOfWeek(new Date(props.selectedDay.date)))
  const [displayedWeek, setDisplayedWeek] = React.useState(eachDayOfInterval({start: startOfWeek(new Date(props.selectedDay.date)), end: endOfWeek(new Date(props.selectedDay.date))}))
  const [weekViewEventObject, setWeekViewEventObject] = React.useState([])
  const [monthName, setMonthName] = React.useState(format(new Date(props.selectedDay.date), 'MMMM yyyy'))

  React.useEffect(() => {
    // Set the container scroll position based on the current time.
    const currentMinute = new Date().getHours() * 60
    container.current.scrollTop = ((container.current.scrollHeight - containerNav.current.offsetHeight - containerOffset.current.offsetHeight) * currentMinute) / 1440
  }, [])

  React.useEffect(() => {
    (format(firstDayOfWeek, 'MMM') === format(lastDayOfWeek, 'MMM')) ? setMonthName(format(firstDayOfWeek, 'MMMM yyyy')) : setMonthName(`${format(firstDayOfWeek, 'MMM')}-${format(lastDayOfWeek, 'MMM yyyy')}`)
  }, [displayedWeek])

  React.useEffect(() => createEventObjectForWeekView(displayedWeek, props.calendarDaysWithEvents, setWeekViewEventObject), [props.calendarDaysWithEvents, displayedWeek])

  return (
    <div className='mx-1 my-4 h-[720px] min-w-[1000px]'>
      <div className="lg:flex lg:h-full rounded-xl min-w-[700px] overflow-hidden lg:flex-col md:flex-col">
      <InternalCalendarMenu view={'Week view'} setView={props.setView} selectedDay={props.selectedDay} setSelectedDay={props.setSelectedDay} calendarDaysWithEvents={props.calendarDaysWithEvents} setFirstDayOfWeek={setFirstDayOfWeek} setLastDayOfWeek={setLastDayOfWeek} setDisplayedWeek={setDisplayedWeek} firstDayOfWeek={firstDayOfWeek} lastDayOfWeek={lastDayOfWeek} monthName={monthName} />
        <div ref={container} className="isolate flex flex-auto flex-col border border-solid border-t-0 border-l-0 border-r-0 mt-4 border-gray-300 overflow-auto">
          <div style={{ width: '165%' }} className="flex max-w-full flex-none flex-col sm:max-w-none md:max-w-full">
            <SmallWeekViewCalendar displayedWeek={displayedWeek} setSelectedDay={props.setSelectedDay} setView={props.setView} containerNav={containerNav} />
            <LargeWeekViewCalendar containerOffset={containerOffset} displayedWeek={displayedWeek} weekViewEventObject={weekViewEventObject} setEditEvent={props.setEditEvent} setEventToEdit={props.setEventToEdit} createNewCalendarEvent={props.createNewCalendarEvent} schoolCalendar={props.schoolCalendar} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default WeekViewCalendar